export default __webpack_public_path__ + "static/media/Login_bg.edf75257.jpeg";